import { compare, getUserType } from './index';

const canBuy = item =>
  !!item &&
  item.quantity > 0 &&
  item.online_price > 0 &&
  item.drugstore_price > 0;

const getPackingName = packing => {
  let name;
  if (packing === 'plate') {
    name = 'plate';
  } else if (packing === 'sachet') {
    name = 'sachet';
  } else if (packing === 'tube_cap') {
    name = 'tube_cap';
  } else {
    name = 'flask';
  }

  return name;
};

const isDisabledForPurchase = item => item.online_price === 0;

const selectArticle = (product, index, vat) => {
  if (!product || index === undefined) {
    return;
  }

  const form = product.release_forms?.[index];
  const itemProps = {
    drugstore_price: product.drugstore_price,
    drugstores_count_available: product.drugstores_count_available,
    drugstores_count_all: product.drugstores_count_all,
    goods_atc_class: product.goods_atc_class,
    goods_atc_class_tree: product.goods_atc_class_tree,
    goods_name: product.goods_name,
    goods_producer: product.goods_producer,
    included_to_offers: product.included_to_offers,
    name: product.name,
    name_ru: product.name_ru,
    name_uk: product.name_uk,
    online_price: product.online_price,
    pic: product.pic,
    quantity: product.quantity,
  };

  const isInsuranceAgent = getUserType() === 'insurance';

  return isInsuranceAgent
    ? {
        ...itemProps,
        ...form,
        group_id: product.id,
        nds: (typeof vat === 'object' ? vat?.id : vat) ?? form?.nds?.[0],
        nds_list: form?.nds
          .map(i => ({
            title: i,
            value: i,
            id: i,
          }))
          .sort(compare),
      }
    : {
        ...itemProps,
        ...form,
        group_id: product.id,
      };
};

export { canBuy, getPackingName, isDisabledForPurchase, selectArticle };
